export const EXERCISE_LIBRARY = {
  full: [
    'Thruster',
    'Burpees',
    'Kettlebell Swing',
    'Farmer Carry',
    'Wall Ball',
    'Devils Press',
    'Push Press',
    'Man Maker',
    'Battle Rope Slams',
    'Air Bike Sprint',
    'Sled Push',
    'Sled Pull',
    'Row Sprint',
    'Ski Erg Sprint',
    'Sandbag Clean',
    'Dumbbell Snatch',
    'Box Jump Over',
    'Shuttle Run',
    'Jump Rope Double Under',
    'Bear Crawl'
  ],
  upper: [
    'Bankdruecken',
    'Dumbbell Bench Press',
    'Incline Bench Press',
    'Schulterdruecken',
    'Rudern',
    'Klimmzuege',
    'Liegestuetz',
    'Dips',
    'Arnold Press',
    'Upright Row',
    'Dumbbell Shrug',
    'Kurzhantel Rudern',
    'Latzug',
    'Face Pull',
    'Seitheben',
    'Frontheben',
    'Overhead Press',
    'Bizepscurls',
    'Hammer Curls',
    'Trizepsdruecken',
    'Skullcrusher',
    'Enges Bankdruecken',
    'Chest Fly',
    'Inverted Row',
    'Pike Push-up',
    'Handstand Hold'
  ],
  lower: [
    'Kniebeugen',
    'Ausfallschritte',
    'Beinpresse',
    'Rumaenisches Kreuzheben',
    'Hip Thrust',
    'Bulgarian Split Squat',
    'Split Squat',
    'Jumping Lunges',
    'Adductor Machine',
    'Abductor Machine',
    'Hack Squat',
    'Step-up',
    'Goblet Squat',
    'Front Squat',
    'Back Squat',
    'Deadlift',
    'Sumo Deadlift',
    'Leg Curl',
    'Leg Extension',
    'Wadenheben',
    'Jump Squat',
    'Skater Jump',
    'Hamstring Slide',
    'Nordic Curl',
    'Glute Bridge'
  ],
  core: [
    'Plank',
    'Dead Bug',
    'Hanging Knee Raise',
    'Lying Leg Raise',
    'Russian Twist',
    'Side Plank',
    'V-Up',
    'Sit-up',
    'Hollow Hold',
    'Mountain Climber',
    'Bicycle Crunch',
    'Cable Crunch',
    'Weighted Crunch',
    'Toe Touch',
    'Bird Dog',
    'Pallof Press',
    'Ab Wheel Rollout',
    'Reverse Crunch',
    'Woodchopper',
    'L-Sit Hold',
    'Superman Hold',
    'Flutter Kicks',
    'Plank Shoulder Tap'
  ]
};

export const EXERCISE_EN_EQUIVALENTS = {
  bankdruecken: 'Bench Press',
  'dumbbell bench press': 'Dumbbell Bench Press',
  'incline bench press': 'Incline Bench Press',
  schulterdruecken: 'Shoulder Press',
  rudern: 'Row',
  klimmzuege: 'Pull-up',
  liegestuetz: 'Push-up',
  'kurzhantel rudern': 'Dumbbell Row',
  latzug: 'Lat Pulldown',
  seitheben: 'Lateral Raise',
  frontheben: 'Front Raise',
  'overhead press': 'Shoulder Press',
  'upright row': 'Upright Row',
  'dumbbell shrug': 'Dumbbell Shrug',
  bizepscurls: 'Biceps Curl',
  skullcrusher: 'Skullcrusher',
  trizepsdruecken: 'Triceps Pushdown',
  'enges bankdruecken': 'Close-Grip Bench Press',
  kniebeugen: 'Squat',
  ausfallschritte: 'Lunge',
  beinpresse: 'Leg Press',
  'adductor machine': 'Adductor Machine',
  'abductor machine': 'Abductor Machine',
  'hack squat': 'Hack Squat',
  'rumaenisches kreuzheben': 'Romanian Deadlift',
  wadenheben: 'Calf Raise',
  'hanging knee raise': 'Hanging Knee Raise',
  'lying leg raise': 'Lying Leg Raise',
  'cable crunch': 'Cable Crunch',
  'weighted crunch': 'Weighted Crunch',
};

export const EXERCISE_SEARCH_ALIASES = {
  'split squat': ['bulgarian split squat', 'split squats'],
  'jumping lunges': ['jumping lunge', 'jumping lungees', 'switch lunge', 'switch lunges'],
  'adductor machine': ['adductor', 'adduktor', 'innere beinmuskel', 'innerer beinmuskel', 'inner thigh'],
  'abductor machine': ['abductor', 'abduktor', 'aeussere beinmuskel', 'aeusserer beinmuskel', 'outer thigh'],
  'dumbbell bench press': ['db bench press', 'kurzhantel bankdruecken'],
  'incline bench press': ['incline press', 'schraegbankdruecken', 'schraegbank'],
  frontheben: ['front raise'],
  schulterdruecken: ['shoulder press', 'overhead press', 'military press'],
  'upright row': ['barbell upright row'],
  'dumbbell shrug': ['shrug', 'dumbbell shrugs'],
  skullcrusher: ['ez bar skullcrusher', 'triceps extension'],
  'hack squat': ['machine hack squat'],
  'lying leg raise': ['lying floor leg raise', 'leg raise'],
  'cable crunch': ['ab cable crunch'],
  'weighted crunch': ['weighted sit up']
};


export const FOCUS_IDS = ['upper', 'lower', 'core', 'full'];
export function normalizeCustomExercises(entries) {
  return entries.filter(Boolean).map((entry) => ({
    name: String(typeof entry === 'string' ? entry : entry.name || '').trim().replace(/\s+/g, ' '),
    focus: FOCUS_IDS.includes(entry.focus) ? entry.focus : 'full'
  })).filter((entry) => entry.name);
}
export function getExerciseFocus(entry, customExercises = []) {
  if (FOCUS_IDS.includes(entry?.focus)) return entry.focus;
  const name = String(typeof entry === 'string' ? entry : entry?.name || '').toLowerCase();
  const custom = customExercises.find((item) => item.name.toLowerCase() === name);
  if (custom) return custom.focus;
  return FOCUS_IDS.find((focus) => EXERCISE_LIBRARY[focus].some((item) => item.toLowerCase() === name)) || 'full';
}
export function searchExercises(names, query, focuses, getFocus) {
  const normalized = String(query || '').trim().toLowerCase();
  return names.filter((name) => {
    // Search text spans the entire catalogue; checkboxes narrow the matches explicitly.
    if (focuses.length && !focuses.includes(getFocus(name))) return false;
    const key = name.toLowerCase();
    return !normalized || [name, EXERCISE_EN_EQUIVALENTS[key], ...(EXERCISE_SEARCH_ALIASES[key] || [])]
      .filter(Boolean).some((label) => label.toLowerCase().includes(normalized));
  });
}
